import { useContext, useEffect, useState } from 'react'
import { useOutletContext } from 'react-router';
import { useTranslation } from 'react-i18next';

import api from 'shared/topchef-api-places';
import { NotificationType, PublicLead } from 'shared/topchef.types'

import { NotificationContext } from 'shared/NotificationContext'
import Loading from 'pages/shared/loading/Loading'
import { PlaceOutletContextType } from '../home/PlacesHome'
import MoreDetailsCellRenderer from 'pages/shared/more-details-renderer/MoreDetailsCellRenderer';

import BriefsMarketMenu from 'pages/places/briefs-market-menu/BriefsMarketMenu';
import { useErrorBoundary } from 'react-error-boundary';
import BriefsList from 'pages/shared/briefs-list/BriefsList'

export interface SharedLeadsLoaderProps {
    title: string,
    showMenu: boolean,
    limit: number | null,
    paginateResults: boolean,
    height: string
}

const SharedLeadsLoader = (props: SharedLeadsLoaderProps) => {

  const { t } = useTranslation();
  const [leadsLoaded, setLeadsLoaded] = useState<boolean>(false);
  const [publicLeads, setPublicLeads] = useState<PublicLead[]>([]);
  
  const notificationContext = useContext(NotificationContext);
  const { triggerNotification } = notificationContext;

  const [loggedInPlace] = useOutletContext<PlaceOutletContextType>();

  const { showBoundary } = useErrorBoundary();

  useEffect(() => { // eslint-disable-line react-hooks/exhaustive-deps

    async function loadSharedLeads() {
      try {
        const leads: PublicLead[] = await api.loadSharedLeads(loggedInPlace!.id, props.limit);
        setPublicLeads(leads);
        setLeadsLoaded(true);
      } catch (error: any) { 
        const newError = new Error(t('apiErrors.loadSharedLeads', { details: error.message }) as string);
        triggerNotification({type: NotificationType.error, message : newError.message});
        return showBoundary(newError);
      } 
    }

    if (leadsLoaded) {
      return;
    }
    loadSharedLeads();

  }, [leadsLoaded, publicLeads, triggerNotification, loggedInPlace, showBoundary, props.limit]); // eslint-disable-line react-hooks/exhaustive-deps


  const moreDetailsRenderer = (params: any) => {
    const leadId: string = params.data.id;
    return (
      <MoreDetailsCellRenderer url={`/places/leads/shared/${leadId}`} label={t('actionLabels.moreDetails')}  />
    );
  };


  if (!leadsLoaded) {
    return (
      <Loading />
    );
  }

  return (
    <div className="page-briefs-transmis container p-5">
      <div id="lead_sidebar" className="d-flex">
        <ul className="nav nav-pills flex-column mb-auto">
          <li className="nav-item"> <a href="/places/share-a-lead" type="button" className="btn btn-outline-primary nav-link add-brief-link">Ajouter un brief</a></li>
        </ul>
      </div>

      <h5 className="mb-3">{props.title}</h5>

      {props.showMenu && <BriefsMarketMenu loggedInPlace={loggedInPlace}/>}

      <BriefsList leads={publicLeads} height={props.height} paginateResults={props.paginateResults} detailsRenderer={moreDetailsRenderer} />
    </div>
  );

}

export default SharedLeadsLoader;
